import React from 'react';
import { rolesID } from '../../constants/rolesID';
import { Layout } from '../../components/Layout';
import { TeamRoutes } from '../../features/team';
import { CompanyRouts } from '../../features/company';
import { SupportRouts } from '../../features/support';
import { MyApplicationsRoutes } from '../../features/my-applications';
import { PartnersRoutes } from '../../features/partners';
import { BonusesRoutes } from '../../features/bonuses';
import { UserPermissionsRoutes } from '../../features/user-permissions';
import { useSelector } from 'react-redux';
import { ProfileRoutes } from '../../features/profile/ProfileRoutes';
import { MailingRoutes } from '../../features/mailing';
import { BASE_PERMISSION_ROLES } from '../../constants/variables';
import { BonusRecordRoutes } from '../../features/bonus-record';
import { CompanyPromotionsRoutes } from '../../features/company-promotions/CompanyPromotionsRoutes';

export const UserContainer = () => {
  const { userData } = useSelector((state) => state.currentUser);
  const userRoleId = userData?.role?.id;

  return (
    <Layout data-testid="UserContainer">
      {<TeamRoutes />}
      {userRoleId === rolesID.ROLE_ADMINISTRATOR && <CompanyRouts />}
      {<SupportRouts />}
      {BASE_PERMISSION_ROLES.includes(userRoleId) && <MyApplicationsRoutes />}
      <PartnersRoutes />
      {<BonusesRoutes />}
      <CompanyPromotionsRoutes />
      {userRoleId === rolesID.ROLE_ADMINISTRATOR && <UserPermissionsRoutes />}
      <ProfileRoutes />
      <MailingRoutes />
      {BASE_PERMISSION_ROLES.includes(userRoleId) && <BonusRecordRoutes />}
    </Layout>
  );
}
